<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="players"
      :chart-value-keys="chartValueKeys"
      :plot-options="{bar: {horizontal: false, borderRadius: 10}}"
      x-value="last_name"
      :y-value-prefix="aggregation && !removable ? 'latest_stats.' : 'player_stats.'"
      :markers="{size: 5}"
      :yaxis="[ { title: { text: $t('gps_variables.volume') }, opposite: true}, { title: { text: $t('gps_variables.intensity') } } ]"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: players.map(p => p.first_name[0] + '. ' + p.last_name ),
        tickPlacement: 'between'
      }"
      :colors="[ '#FEB019', '#008FFB' ]"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('card_title.volume_and_intensity') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.volume_and_intensity') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="players"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        dense
        :height="350"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'

export default {
  name: 'VolumeIntensityChart',
  components: { LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      return [
        { key: addAggregation('UXINTS'), type: 'bar', label: this.$t('gps_variables.intensity') },
        { key: addAggregation('UXVOL'), label: this.$t('gps_variables.volume') }
      ]
    },
    tableHeaders() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      const valuePrefix = this.aggregation && !this.removable ? 'latest_stats.' : 'player_stats.'

      return [
        {
          text: this.$t('table_headers.name'),
          value: 'last_name',
          sortable: true,
          width: '40%'
        },
        {
          text: this.$t('gps_variables.intensity'),
          value: valuePrefix + addAggregation('UXINTS'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('gps_variables.volume'),
          value: valuePrefix + addAggregation('UXVOL'),
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
